import React from 'react';
import styled from 'styled-components';
import img from '../../../assets/images/simplepay_bankcard_logos_left-hu.png';

const PaymentLogos = () => {
  return (
    <Root>
      <a
        href="http://simplepartner.hu/PaymentService/Fizetesi_tajekoztato.pdf"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={img} alt="SimplePay" />
      </a>
    </Root>
  );
};

export default PaymentLogos;

const Root = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  height: 100%;
  padding-top: 16px;
  width: 100%;

  & * {
    width: 100%;
  }
`;
